import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HeatingConsumptionPage } from './heating-consumption';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		HeatingConsumptionPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(HeatingConsumptionPage),
	],
})
export class HeatingConsumptionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/heating-consumption/heating-consumption.module.ts